import { Delete, Edit, Visibility } from "@mui/icons-material";
import { IconButton } from "@mui/material";

export const getHospitalsColumns = (
  handleView: any,
  handleEdit: any,
  handleDelete: any
) => {
  return [
    {
      field: "_id",
      headerName: "ID",
      width: 100,
      editable: false,
    },
    {
      field: "address",
      headerName: "City",
      width: 200,
      editable: true,
      valueGetter: (params: any) => {
        return params?.city || "N/A";
      },
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 100,
      editable: true,
    },
    {
      field: "email",
      headerName: "Email",
      width: 100,
      editable: true,
    },
    {
      field: "availableBedsRatio",
      headerName: "Available Beds",
      width: 100,
      editable: true,
      valueGetter: (_: any, row: any) => {
        return `${(row?.availableBeds || 0)} / ${(row?.totalBeds || 0)}`;
      },
    },
    {
      field: "icuAvailableBedsRatio",
      headerName: "Available ICU Beds",
      width: 100,
      editable: true,
      valueGetter: (_: any, row: any) => {
        return `${(row?.icuAvailableBeds || 0)} / ${(row?.icuBeds || 0)}`;
      },
    },
    {
      field: "ventilatorAvailableBedsRatio",
      headerName: "Available Ventilator Beds",
      width: 100,
      editable: true,
      valueGetter: (_: any, row: any) => {
        return `${(row?.ventilatorAvailableBeds || 0)} / ${(row?.ventilatorBeds || 0)}`;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      sortable: false,
      filterable: false,
      renderCell: (params: any) => (
        <>
          <IconButton
            color="primary"
            aria-label="view user"
            onClick={() => handleView(params.row)}
          >
            <Visibility />
          </IconButton>
          <IconButton
            color="secondary"
            aria-label="edit user"
            onClick={() => handleEdit(params.row)}
          >
            <Edit />
          </IconButton>
          <IconButton
            color="error"
            aria-label="delete user"
            onClick={() => handleDelete(params.row)}
          >
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];
};
